import { render } from "./MyBusinessType.vue?vue&type=template&id=d3d912e4"
import script from "./MyBusinessType.vue?vue&type=script&lang=js"
export * from "./MyBusinessType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__